export const generateUniqueTitle = (title: string, existingTitles: string[]): string => {
  const copyRegex = /(.*?)( \(copy(?: (\d+))?\))$/;
  let baseTitle: string;
  let copyNumber: number;
  const match = title.match(copyRegex);

  if (match) {
    baseTitle = match[1];
    copyNumber = match[3] ? parseInt(match[3], 10) : 1;
  } else {
    baseTitle = title;
    copyNumber = 0;
  }

  let newTitle: string;
  do {
    copyNumber += 1;
    newTitle = `${baseTitle} (copy${copyNumber > 1 ? ` ${copyNumber}` : ''})`;
  } while (existingTitles.includes(newTitle));

  return newTitle;
};
